<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :options="[
        { type: 'date', label: '점검일'},
        { type: 'text', label: '점검장소'},
        { type: 'disaster', label: '재해형태'}
      ]" :board="this.board" :is-print="isPrint"/>

    <!--    표-->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :is-not-dot-in-label="true"
      title="복도 및 화장실 청소 작업"
      tableHeaderTitle="점검항목"
      :list="form.inspectList_1"
      @update-list-check="updateListCheck_1"
    />

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"/>

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspect from '@/components/TableInspect'

export default {
  components: {
    TableInspect,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        photoList: [],
        inspectList_1: [
          {
            id: 1,
            label: "1. 바닥에 작업자가 걸려 넘어질 위험이 있는 장애물은 제거하였는가?",
            is_checked: "",
          },
          {
            id: 2,
            label: "2. 근로자의 통행에 장해가 없도록 채광 또는 조명시설이 충분한가?",
            is_checked: "",
          },
          {
            id: 3,
            label: "3. 교차점이나 코너에는 충돌방지용 거울을 설치하였는가?",
            is_checked: "",
          },
          {
            id: 4,
            label: "4. 다른 사람과 충돌을 방지하기 위해 우측통행을 하는가? ",
            is_checked: "",
          },
          {
            id: 5,
            label: "5. 화장실 타일이 깨지거나 비어있는 부분은 없는가?",
            is_checked: "",
          },
          {
            id: 6,
            label: "6. 청소 전 화장실 내부에 사람이 있는 지 확인하였는가?",
            is_checked: "",
          },
          {
            id: 7,
            label: "7. 화장실 천정이나 높은 벽 청소 시 사용하는 사다리에 미끄럼방지 조치를 하였는가? ",
            is_checked: "",
          },
          {
            id: 8,
            label: "8. 화장실 세면대나 변기 위에 올라가서 작업을 하지 않는가?",
            is_checked: "",
          },
          {
            id: 9,
            label: "9. 청소 중에는 “청소 중”을 알리는 표지를 하고 작업하는가?",
            is_checked: "",
          },
          {
            id: 10,
            label: "10. 청소 후 바닥에 미끄러운 세제나 물기를 깨끗이 제거하는가?",
            is_checked: "",
          },
          {
            id: 11,
            label: "11. 청소도구를 지정된 위치에 보관하는가?",
            is_checked: "",
          },
          {
            id: 12,
            label: "12. 자극성 세제를 이용한 청소 시 고무장갑을 착용하는가?",
            is_checked: "",
          },
          {
            id: 13,
            label: "13. 청소 중에는 미끄럼 방지용 장화를 착용하는가?",
            is_checked: "",
          },

        ],
      },
    };
  },
  methods: {
    updateListCheck_1 (indexRows, text) {
      this.form.inspectList_1[indexRows].is_checked = text
    },
  },
};
</script>

<style scoped lang="scss">
</style>
